/**
 * Category Utilities
 *
 * Utility functions for category-related operations
 */

export {
  mapCategoriesToCardProps,
  getCategoryImagePath,
  enhanceCategoryWithImage,
} from './mappers';

export {
  getCategoryImageUrl,
  isValidImageUrl,
  CATEGORY_IMAGE_MAP,
} from './categoryImages';
